var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ViewsConfiguratorV2',{attrs:{"value":_vm.sections,"realm":_vm.realm,"subscription":_vm.subscription},on:{"input":_vm.onChildInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }